export const toScientific = (num, digits = 2) => {
    if (num === null || num === undefined || num === "") return "";
    const n = Number(num);
    if (!Number.isFinite(n)) return String(num);
    return n.toExponential(digits);
};

export const sciPretty = (num, digits = 2) => {
    const s = toScientific(num, digits); // e.g. "5.01e-4"
    if (!s) return "";
    const m = String(s).match(/^(-?\d+(?:\.\d+)?)[eE]([+-]?\d+)$/);
    if (!m) return s;
    const [, mantissa, exp] = m;
    return { mantissa, exp }
}